const getSearchResultCol = ({ search_type, searchResultCard }) => {
  return;
}

const getSearchResultCard = ({ search_type, data }) => {
  return;
}

const getSearchResultMapFeatureProps = ({ data }) => {
  return;
}

const getSearchResultColProps = ({ data }) => {

  return {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12,
  }

}

const getSearchResultCardProps = ({ data, search_type }) => {

  switch (search_type) {
    case "map": {
      const onClick = () => {
        // window.open(data.link, '_blank');
      }
      return {
        className: "cursor-pointer",
        onClick: onClick,
      }
    }
    default:
      const onClick = () => {
        // window.location.href = data.link;
      }
      return {
        className: "h-100 cursor-pointer rounded-4 border-0 shadow",
        onClick: onClick,
      }
      break;
  }

}

export {
  getSearchResultCol, getSearchResultCard,
  getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps
};
